import { fetchWP } from "../wordpress";

interface SubmitFormProps {
  company?: string;
  name?: string;
  surname?: string;
  email?: string;
  phone?: string;
  date?: string;
  time?: string;
  guests?: string;
  venue?: string;
}

export async function submitFormDrinks(props: SubmitFormProps): Promise<any> {
  try {
    const { company, name, surname, email, phone, date, venue, guests, time } = props;

    const mutation = `
      mutation SubmitForm {
        submitGfForm(
          input: {
            id: 2,
            fieldValues: [
              { id: 10, nameValues: {first: "${date}"} },
              { id: 11, nameValues: {first: "${name}"} },
              { id: 6, nameValues: {first: "${surname}"} },
              { id: 8, emailValues: { value: "${email}" } },
              { id: 9, value: "${phone}" },
              { id: 3, nameValues: {first: "${time}"} },
              { id: 7, nameValues: {first: "${company}"} },
              { id: 5, nameValues: {first: "${venue}"} },
              { id: 4, nameValues: {first: "${guests}"} },
            ]
          }
        ) {
          confirmation {
            type
            message
            url
          }
          errors {
            id
            message
          }
        }
      }`;

    const response = await fetchWP(mutation);

    if (response?.submitGfForm?.errors?.length > 0) {
      console.error('formSubmit: Form submission errors:', response.submitGfForm.errors);
      return { success: false, errors: response.submitGfForm.errors };
    }

    // console.log('formSubmit: Form submitted successfully:', response.submitGfForm.confirmation);
    return { success: true, confirmation: response.submitGfForm.confirmation };
  } catch (error) {
    console.error('formSubmit: Error submitting form:', error);
    return { success: false, error };
  }
}

interface SubmitFormMeetingProps {
  company?: string;
  name?: string;
  surname?: string;
  email?: string;
  phone?: string;
  date?: string;
  guests?: string;
  rooms?: string;
}
export async function submitFormMeeting(props: SubmitFormMeetingProps): Promise<any> {
  try {
    const { company, name, surname, email, phone, date, rooms, guests } = props;

    const mutation = `
      mutation SubmitForm {
        submitGfForm(
          input: {
            id: 3,
            fieldValues: [
              { id: 10, nameValues: {first: "${date}"} },
              { id: 6, nameValues: {first: "${name}", last: "${surname}"}},
              { id: 8, emailValues: { value: "${email}" } },
              { id: 9, value: "${phone}" },
              { id: 7, nameValues: {first: "${company}"} },
              { id: 3, nameValues: {first: "${rooms}"} },
              { id: 4, nameValues: {first: "${guests}"} },
            ]
          }
        ) {
          confirmation {
            type
            message
            url
          }
          errors {
            id
            message
          }
        }
      }`;

    const response = await fetchWP(mutation);

    if (response?.submitGfForm?.errors?.length > 0) {
      console.error('formSubmit: Form submission errors:', response.submitGfForm.errors);
      return { success: false, errors: response.submitGfForm.errors };
    }

    console.log('formSubmit: Form submitted successfully:', response.submitGfForm.confirmation);
    return { success: true, confirmation: response.submitGfForm.confirmation };
  } catch (error) {
    console.error('formSubmit: Error submitting form:', error);
    return { success: false, error };
  }
}

interface SubmitFormContactProps {
  name?: string;
  email?: string;
  phone?: string;
  message?: string;
}
export async function submitFormContact(props: SubmitFormContactProps): Promise<any> {
  try {
    const { name, email, phone, message } = props;

    const mutation = `
      mutation SubmitForm {
        submitGfForm(
          input: {
            id: 1,
            fieldValues: [
              { id: 2, nameValues: {first: "${name}"} },
              { id: 4, emailValues: { value: "${email}" } },
              { id: 5, value: "${phone}" },
              { id: 6, value: "${message}" },
            ]
          }
        ) {
          confirmation {
            type
            message
            url
          }
          errors {
            id
            message
          }
        }
      }`;

    const response = await fetchWP(mutation);

    if (response?.submitGfForm?.errors?.length > 0) {
      console.error('formSubmit: Form submission errors:', response.submitGfForm.errors);
      return { success: false, errors: response.submitGfForm.errors };
    }

    console.log('formSubmit: Form submitted successfully:', response.submitGfForm.confirmation);
    return { success: true, confirmation: response.submitGfForm.confirmation };
  } catch (error) {
    console.error('formSubmit: Error submitting form:', error);
    return { success: false, error };
  }
}

